"use client";

import { useEffect, useState } from "react";
import { CoachMarks, type CoachMarkStep } from "./CoachMarks";
import { useOnboarding } from "@/lib/use-onboarding";
import { useWorkspace } from "@/lib/workspace-context";

const TOUR_KEY = "wiki_arsenal_tour_done";

const TOUR_STEPS: CoachMarkStep[] = [
  {
    target: "[data-tour='file-explorer']",
    title: "Tu explorador de archivos",
    description: "Aquí ves todas tus notas y carpetas. Crea nuevas con los botones + o haz drag & drop para moverlas.",
    placement: "right",
  },
  {
    target: "[data-tour='editor-tabs']",
    title: "Pestañas y split view",
    description: "Abre varios documentos a la vez. Usa el ícono ⎘ para dividir la pantalla y comparar dos notas.",
    placement: "bottom",
  },
  {
    target: "[data-tour='editor-toolbar']",
    title: "Formato rápido",
    description: "Negrita, cursiva, código, wiki-links. Selecciona texto para ver más opciones flotantes.",
    placement: "bottom",
  },
  {
    target: "[data-tour='graph-button']",
    title: "Tu red de conocimiento",
    description: "Visualiza cómo se conectan tus notas. Click en un nodo para abrirlo.",
    placement: "left",
  },
  {
    target: "[data-tour='command-palette']",
    title: "Command Palette",
    description: "Presiona ⌘K desde cualquier lugar para buscar notas, abrir páginas o ejecutar acciones.",
    placement: "right",
  },
];

/**
 * Tour completo del workspace. Se muestra:
 *  - Primera vez que el usuario entra al workspace
 *  - Cuando presiona `?` (manejado en el ShortcutsOverlay)
 *
 * Persiste el "done" en localStorage.
 */
export function OnboardingTour() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const handleStartTour = () => {
      setActive(true);
    };
    window.addEventListener("wiki:start-tour", handleStartTour);
    return () => window.removeEventListener("wiki:start-tour", handleStartTour);
  }, []);

  const handleComplete = () => {
    localStorage.setItem(TOUR_KEY, "1");
    setActive(false);
  };

  return (
    <CoachMarks
      active={active}
      steps={TOUR_STEPS}
      onComplete={handleComplete}
    />
  );
}
